import { compose, curry } from "ramda"
import isAddress from "./validators/isAddress"
import isAlphanumeric from "./validators/isAlphanumeric"
import isAssociatedBRFields from "./validators/isAssociatedBRFields"
import { isAssociatedCity, isAssociatedState } from "./validators/isAssoiatedRegion"
import isCompanyNameCH from "./validators/isCompanyNameCH"
import isCompanyNameEN from "./validators/isCompanyNameEN"
import isContactName from "./validators/isContactName"
import isEmail from "./validators/isEmail"
import isHKBrNumberFormat from "./validators/isHKBrNumberFormat"
import isNotHKBrNumberFormat from "./validators/isNotHKBrNumberFormat"
import { isFieldNumber } from "./validators/isNumber"
import isOptional from "./validators/isOptional"
import isRequired from "./validators/isRequired"
import isRequiredFields from "./validators/isRequiredFields"

export const getFieldValueObject = curry((fieldName, { value }) => {
  return { value: value[fieldName] }
})

const rules = {
  fields: {
    email: {
      isRequired,
      isEmail
    },
    nameEN: {
      isRequired,
      isCompanyNameEN
    },
    nameTC: {
      isCompanyNameTC: isOptional(isCompanyNameCH)
    },
    nameSC: {
      isCompanyNameSC: isOptional(isCompanyNameCH)
    },
    contactPerson: {
      isRequired: isRequiredFields(["title", "firstName", "lastName"], true),
      isFirstName: isContactName("firstName"),
      isLastName: isContactName("lastName")
    },
    telephone: {
      isRequired: isRequiredFields(["countryCode", "number"], true),
      isPhoneNumber: compose(isFieldNumber(30), getFieldValueObject("number")),
      isAreaCodeNumber: compose(isOptional(isFieldNumber(8)), getFieldValueObject("areaCode")),
      isExtensionNumber: compose(isOptional(isFieldNumber(15)), getFieldValueObject("extension"))
    },
    address: {
      isRequired: isRequiredFields(["firstRow"], true),
      isFirstRow: compose(isOptional(isAddress), getFieldValueObject("firstRow")),
      isSecondRow: compose(isOptional(isAddress), getFieldValueObject("secondRow")),
      isThirdRow: compose(isOptional(isAddress), getFieldValueObject("thirdRow")),
      isFourthRow: compose(isOptional(isAddress), getFieldValueObject("fourthRow"))
    },
    region: {
      country: {
        isRequired
      },
      state: {
        isAssociated: isAssociatedState(["region", "country"])
      },
      city: {
        isAssociated: isAssociatedCity(["region", "country"])
      }
    },
    natureOfBusiness: {
      isRequired
    },
    emailLangPef: {
      isRequired
    },
    saleRepCode: {
      isSaleRepCode: isOptional(isAlphanumeric(14))
    },
    BRDetails: {
      number: {
        isAssociated: isAssociatedBRFields([
          ["BRDetails", "file"],
          ["BRDetails", "commencementDate"],
          ["BRDetails", "expiryDate"]
        ]),
        isHKBRNumber: isOptional(isHKBrNumberFormat(20)),
        isNotHKBRNumber: isOptional(isNotHKBrNumberFormat(20))
      },
      commencementDate: {
        isAssociated: ({ value, forminputdata }) => {
          return forminputdata?.region?.country?.id === "HKG"
            ? isAssociatedBRFields([
                ["BRDetails", "file"],
                ["BRDetails", "number"],
                // ["BRDetails", "commencementDate"],
                ["BRDetails", "expiryDate"]
              ])({ value, forminputdata })
            : true
        }
      },
      expiryDate: {
        isAssociated: ({ value, forminputdata }) => {
          return forminputdata?.region?.country?.id === "HKG"
            ? isAssociatedBRFields([
                ["BRDetails", "file"],
                ["BRDetails", "number"],
                ["BRDetails", "commencementDate"]
                // ["BRDetails", "expiryDate"]
              ])({ value, forminputdata })
            : true
        }
      },
      file: {
        isAssociated: isAssociatedBRFields([
          // ["BRDetails", "file"],
          ["BRDetails", "number"],
          ["BRDetails", "commencementDate"],
          ["BRDetails", "expiryDate"]
        ])
      }
    }
  }
}

export default rules
